import React, {useEffect, useRef, useState} from 'react';
import ProductImageCollection from "./ProductImageCollection";
import createLightGallery from "../../../../Common/services/createLightGallery";

// Image box on the left side of the clustered item page.
// Modernised 2024-05
export default function SingleItemImageDisplay({product, showZoom=false}) {
  const ref = useRef(null);
  const [gallery, setGallery] = useState(null);

  const image = getImageFromProduct(product);

  // Destroy and recreate gallery when the image changes
  useEffect(() => {
    if (!ref || !image) return;

    if (gallery && gallery.destroy) {
      gallery.destroy();
    }

    // console.log("create gallery, image is " + image);
    const lg = createLightGallery(ref.current);
    setGallery(lg);
  }, [ref, image])

  if (!image) {
    console.log("no image for product " + product.id, product);
    return null;
  }

  return <div ref={ref} className="image-box text-center pb-2 relative ">
    <a className="inline-block pic" href={image}><img
      className="max-w-full max-h-52"
      alt={product.name} src={image}/>
      {showZoom && <div className="absolute bottom-0 right-0"><span className="fa fa-expand" /></div>}
    </a>
  </div>
}


function getImageFromProduct(product) {
  if (!product) return null;

  const coll = new ProductImageCollection({product: product});
  return coll.getFirstImagePath('large');
}
